import React, { useEffect } from "react"
import { IconSeeker } from "@ui-seeker/core"
import { isCsvLoading } from "Pages/ReportsAlerts/Reports/@signals"
import { useSignal } from "@preact/signals-react"
import { Box } from "@mui/material"
import { AppBulkEditAction } from "@components"

export default function UploadCsvButton({ fileRef, onSubmit }) {

	const input = useSignal(null)

	useEffect(() => {
		if (!!input.value) {
			onSubmit(input.value)
			isCsvLoading.value = true
		}
		if (!isCsvLoading.value) input.value = null
	}, [input.value])


	// 38px as the template button beside it
	return <AppBulkEditAction
		sx={{ height: 38 }}
		startIcon={<IconSeeker icon="upload"/>}
		loading={isCsvLoading.value}
		component="label"
	>
		<Box display={'none'}>
			<input
				type="file"
				ref={fileRef}
				onChange={e => {
					input.value = e.target.files[0]
				}}
			/>
		</Box>
		{isCsvLoading.value ? "Loading..." : "Upload CSV"}
	</AppBulkEditAction>
}